const Data = {
  productItems: [
    {
      id: "productos-relojesPared/1",
      discount: 50,
      cover: "./images/relojes/1a-reloj.jpg",
      name: "Reloj 1",
      price: 100,
    },
    {
      id: "productos-relojesPared/2",
      discount: 50,
      cover: "./images/relojes/2a-reloj.jpg",
      name: "Reloj 2",
      price: 100,
    },
    {
      id: "productos-paraguas/1",
      discount: 50,
      cover: "./images/paraguas/1-paraguas.jpg",
      name: "Paraguas Negro",
      price: 100,
    },
    {
      id: "productos-paraguas/2",
      discount: 50,
      cover: "./images/paraguas/2-paraguas.jpg",
      name: "Paraguas Grande",
      price: 100,
    },
    {
      id: "productos-mochilas/1",
      discount: 50,
      cover: "./images/mochilas/1-mochila.jpg",
      name: "Mochila Negra",
      price: 100,
    },
    {
      id: "productos-mochilas/2",
      discount: 50,
      cover: "./images/mochilas/2-mochila.jpg",
      name: "Mochila Gris",
      price: 100,
    },
  ],
}
export default Data
